module.exports = __webpack_public_path__ + "shutterstock_196238198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/shutterstock_196238198.jpg
// module id = 271
// module chunks = 0